import * as React from 'react';

export function SuccessIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7325 4.68045L6.66542 13.3681L1.36719 9.0412L2.63226 7.49214L6.47688 9.99997L13.2669 3.31955L14.7325 4.68045Z"
        fill="#737a8e"
      />
    </svg>
  );
}
